"use client";

// Cheap client-side "is there a session cookie" check for UI branching only
// (nav links, redirect targets). Never a security boundary — every gated
// route re-verifies with currentUser() on the server.
export function hasSessionCookie(): boolean {
  return typeof document !== "undefined" && document.cookie.includes("-auth-token");
}
